import styled from "styled-components";
import { tabletRange, mobileRange } from "../../common/styles/breakpoints";
import { colors } from "../../common/styles/variables";

export const OuterContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: white;
    position: fixed;
    bottom: 0;
    padding: 24px 48px;
    gap: 16px;
    z-index: 100;
    width: 100%;

     @media ${mobileRange} {
        flex-direction: column;
        padding: 16px 24px;
        justify-content: flex-start;
        gap: 16px;
    }

    @media ${tabletRange} {
        flex-direction: column;
        gap: 16px
    }
`;

export const CookieInfo = styled.div`
    flex-basis: 50%;

    h5{
        font-size: 24px;

        @media ${mobileRange} {
            font-size: 16px;
        }

        @media ${tabletRange} {
            font-size: 20px;
        }
    }

    p {
        font-size: 16px;

        @media ${mobileRange} {
            font-size: 14px;
        }
    }
`;

export const OverlayImage = styled.div`
    background: #004251;
    position: fixed;
    top: 0;
    left: 0;
    opacity: 0.6;
    z-index: 99;
    width: 100vw;
    height: 100vh;
`;

export const PrimaryButton = styled.button`
    outline: none;
    border: 1px solid ${colors.sherpa_blue};
    border-radius: 5px;
    color: ${colors.white};
    font-size: 16px;
    padding: 9px 16px;
    background: ${colors.sherpa_blue};
    width: 218px;
`;

export const SecondaryButton = styled.button`
    outline: none;
    border: 1px solid ${colors.bondi_blue};
    border-radius: 5px;
    color: ${colors.white};
    font-size: 16px;
    padding: 9px 16px;
    background: ${colors.bondi_blue};
    width: 218px;
`

export const OutlineButton = styled.button`
    outline: none;
    border: 1px solid ${colors.sherpa_blue};
    border-radius: 5px;
    color: ${colors.sherpa_blue};
    font-size: 16px;
    padding: 9px 16px
    width: 218px;
`;

export const CookieButtonContainer = styled.div`
    flex-basis: 60%;
    display: flex;
    gap: 6px;

    @media ${mobileRange} {
        display: flex;
        flex-direction: column-reverse;
        gap: 16px;
    }

    @media ${tabletRange} {
        gap: 16px;
    }
`;

export const ModalButtonContainer = styled.div`
    text-align: right;
    flex-basis: 40%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    p {
        color: ${colors.bondi_blue}
    }

    button:first-child {
        margin-bottom: 16px;

        @media ${mobileRange} {
            margin-bottom: 0;
        }

    }

    @media ${mobileRange} {
        display: flex;
        align-items: center;
        justify-content: end;
        gap: 8px
        width: 100%;

    }
`;

export const Modal = styled.div`
    position: fixed;
    top: 20px;
    left: 50%;
    // width: 800px;
    transform: translateX(-50%);
    z-index: 1001;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;

    @media ${mobileRange} {
        position: fixed;
        width: 100%;
        bottom: 0;
        top: unset;
        max-width: 100%;
        display: flex;
        align-items: end;
    }

    @media ${tabletRange} {
        width: 580px;
    }
`

export const ModalInnerContainer = styled.div`
    background: white;
    width: 50%;
    padding: 24px 32px;
    border-radius: 8px;

    @media ${mobileRange} {
        width: 100%;
         border-radius: 0;
    }

    @media ${tabletRange} {
        width: 100%;
    }
`;

export const CustomCookieSection = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 32px;
    gap: 16px;

    @media ${mobileRange} {
        flex-direction: ${props => props.alignment ? props.alignment : "row"}
        align-items: flex-end;
    }

    h5 {
        font-size: 20px;
    }

    p {
        font-size: 16px;
        font-weight: 400;
    }
`;

export const dashedLine = styled.div`
    position: relative;
    height: 1px;
    background: linear-gradient(to right, #004251 50%, transparent 20%);
    background-size: 10px 100%;
    background-repeat: repeat-x;
    margin: 24px 0;
`;